import React from 'react'

import Popup from 'reactjs-popup'
import { ButtonRound } from '../../../../components/Header/styles'
import { FaFilter } from 'react-icons/fa6'
import { Form } from '../../../../components/commons'
import { Container, Title } from './styles'
import { SelectDocumentType } from '../../../../components/Modals/ModalUpload'
import { useForm } from 'react-hook-form'
import { api } from '../../../../services/api'
import SelectInput from '../../../../components/Input/SelectInput'

export interface FavoriteProps {
  setFilter: (filter: any) => void
  filter: any
}

const Filters: React.FunctionComponent<FavoriteProps> = ({ setFilter, filter }) => {
  const [options, setOptions] = React.useState([])
  const {
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<{ documentType: string; selectedIndex: string }>({})

  const documentType = watch('documentType')
  const selectedIndex = watch('selectedIndex')

  const onGetOptions = async () => {
    try {
      const { data: response } = await api.get(`/documentTypes/${documentType}`)
      setOptions(response.metadata)
    } catch (error) {}
  }

  React.useEffect(() => {
    setFilter({
      documentType,
      selectedIndex,
    })
  }, [documentType, selectedIndex])

  React.useEffect(() => {
    if (documentType && documentType !== '') {
      onGetOptions()
    }
  }, [documentType])

  React.useEffect(() => {
    setValue('documentType', filter?.documentType)
    setValue('selectedIndex', filter?.selectedIndex)
  }, [])

  return (
    <>
      <div id='portalMenu' />
      <Popup
        trigger={
          <ButtonRound>
            <FaFilter color='white' />
          </ButtonRound>
        }
        position='bottom right'
      >
        <Container>
          <Form>
            <Title>Filtrar</Title>
            <SelectDocumentType
              menuPortalTarget={document.querySelector('#portalMenu')}
              menuPosition={'fixed'}
              control={control}
            />

            <SelectInput
              menuPortalTarget={document.querySelector('#portalMenu')}
              control={control}
              menuPosition={'fixed'}
              zIndex={9999}
              label='Selecionar Index'
              name='selectedIndex'
              isClearable
              options={options.map((op: any) => ({
                label: op.name,
                value: op.name,
              }))}
            />
          </Form>
        </Container>
      </Popup>
    </>
  )
}

export default Filters
